<div class="home cover-image">
    <div class="p-20">
        <div *ngIf="isDowntime" class="bannerContent">
            <topaz-banner bannerType="alert" useIcon disableScrolling glow disableCloseButton [restoreFocus]="true">
                <div banner-content class="topaz-banner-subcontent downtime-message-focus" role="alert"
                    aria-live="assertive" aria-atomic="true" tabindex="0">
                    <span class="topaz-banner-subcontent" [innerHTML]="downTimeMessage"></span>
                </div>
                <div banner-action>
                    <button type="button" class="downtime-close-btn" aria-label="Close downtime banner"
                        (click)="closeDowntimeBanner()">
                        &#x2715;
                    </button>
                </div>
            </topaz-banner>
        </div>
        <app-page-header [pageTitle]="username ? 'Welcome, ' + username : 'Welcome'"></app-page-header>
        <ng-container *ngIf="isHomePageLoading; else homeContent">
            <app-user-page-loader label="Loading home information"></app-user-page-loader>
        </ng-container>
        <ng-template #homeContent>
            <div class="session-list-nav" *ngIf="isSessionListBtn">
                <button type="button" class="session-list-link" (click)="navigateToDashboard()">
                    Navigate to Session List
                </button>
            </div>


            <div *ngIf="status==='APPROVE'" class="bannerContent">
                <topaz-banner bannerType="alert" useIcon disableScrolling disableCloseButton>
                    <div banner-content class="topaz-banner-subcontent">
                        <b>🎉 Congratulations! Your MCT application has been pre-approved!</b>
                        <br />
                        <span class="topaz-banner-subcontent">
                            Welcome to the Microsoft Certified Trainer Community!
                            To complete your enrollment and activate your subscription benefits,
                            please submit your payment as soon as possible.
                            <br />
                            If you have any questions or need assistance,contact us at
                            <a href="mailto:mctpvsupport@pearson.com"
                                aria-label="Email MCT Support at mctpvsupport@pearson.com">mctpvsupport&#64;pearson.com</a>—
                            we’re here to help!
                        </span>
                    </div>
                    <div banner-action>
                        <button aria-label="Pay now" (click)="onClickPaynow()" mat-button class="button">Pay
                            now</button>
                    </div>
                </topaz-banner>
            </div>

            <div *ngIf="status==='REINSTATE_APPROVE'" class="bannerContent">
                <topaz-banner bannerType="alert" useIcon disableScrolling disableCloseButton>
                    <div banner-content class="topaz-banner-subcontent">
                        <b>🎉 Congratulations! Your MCT Reinstatement application has been pre-approved!</b>
                        <br />
                        <span class="topaz-banner-subcontent">
                            We’re thrilled to have you back in the MCT community and appreciate your continued
                            commitment to
                            sharing knowledge.
                            To complete your reinstatement, please submit your dues payment within the next <strong>30
                                days</strong>.
                            If payment is not received within this timeframe, your pre-approval will expire,
                            and you’ll need to reapply.
                            <br />
                            If you have any questions or need assistance,
                            contact us at <a href="mailto:mctpvsupport@pearson.com"
                                aria-label="Email MCT Support at mctpvsupport@pearson.com">mctpvsupport&#64;pearson.com</a>—we’re
                            here to help!
                        </span>
                    </div>
                    <div banner-action>
                        <button (click)="onClickPaynow()" mat-button class="button">Pay now</button>
                    </div>
                </topaz-banner>
            </div>

            <div *ngIf="status==='RENEWAL_APPROVE'" class="bannerContent">
                <topaz-banner bannerType="alert" useIcon disableScrolling disableCloseButton>
                    <div banner-content class="topaz-banner-subcontent">
                        <b>🎉 Congratulations - You've met the renewal requirement!</b>
                        <br />
                        <span class="topaz-banner-subcontent">
                            Thank you for completing your renewal application. Please proceed to completing your payment
                            and renewing your subscription and benefits.
                            <br />
                            For questions, please contact us at <a
                                aria-label="Email MCT Support at mctpvsupport@pearson.com"
                                href="mailto:mctpvsupport@pearson.com">mctpvsupport&#64;pearson.com</a> - we’re here to
                            help!
                        </span>
                    </div>
                    <div banner-action>
                        <button (click)="onClickPaynow()" mat-button class="button">Pay now</button>
                    </div>
                </topaz-banner>
            </div>


            <div *ngIf="status==='TEST_OUT_OPEN'" class="bannerContent">
                <topaz-banner bannerType="alert" useIcon disableScrolling disableCloseButton>
                    <div *ngIf="previousStatus != 'RENEWAL'" banner-content class="topaz-banner-subcontent">
                        <b>Continue Your MCT Enrollment</b>
                        <br />
                        <span class="topaz-banner-subcontent">
                            To complete your enrollment and activate your subscription,
                            you must register for and pass the MCT Instructional Skills Assessment,
                            and then pay your MCT Program Fee.
                        </span>
                    </div>
                    <div *ngIf="previousStatus === 'RENEWAL'" banner-content class="topaz-banner-subcontent">
                        <b>Rejoin in the MCT Program!</b>
                        <br />
                        <span class="topaz-banner-subcontent">

                            To rejoin the MCT Program, you must register for and pass the fee-based MCT Instructional
                            Skills Assessment.
                            Once you have passed the assessment, you can complete registration by paying your MCT
                            Program Fee.
                            To learn more about the MCT Instructional Skills Assessment,
                            please visit: <a href="https://aka.ms/Instructional_Skills_Assessment"
                                target="_blank">aka.ms/Instructional_Skills_Assessment</a>
                        </span>
                    </div>
                    <div banner-action>
                        <button (click)="onClickPaynow()" mat-button class="button">Pay now</button>
                    </div>
                </topaz-banner>
            </div>


            <ng-container *ngIf="status==='TEST_OUT_PAYMENT'">

                <div class="bannerContent">
                    <topaz-banner bannerType="success" useIcon disableScrolling disableCloseButton>
                        <div banner-content class="topaz-banner-subcontent">
                            <span class="topaz-banner-subcontent">
                                Thanks for your payment. You will receive an email from our assessment partner,
                                <span style="font-weight: 600;">Yoodli</span>, within the next 48 hours. The email will
                                provide access to the <span style="font-weight: 600;">Yoodli</span> platform,
                                where you will complete the <span style="font-weight: 600;">MCT Instructional Skills
                                    Assessment.</span>
                                Once completed, your scores will be updated in the MCT Portal, and you may proceed with
                                the applicable next steps.
                            </span>
                        </div>
                    </topaz-banner>
                </div>
            </ng-container>

            <ng-container *ngIf="status==='TEST_OUT_PASS'" class="bannerContent">
                <topaz-banner bannerType="success" useIcon disableScrolling disableCloseButton>
                    <div banner-content class="topaz-banner-subcontent">
                        <b>Congratulations!</b> <br />
                        <span class="topaz-banner-subcontent">
                            You have passed the MCT Instructional Skills Assessment. Please complete payment of your
                            annual
                            program fee to activate your MCT subscription.
                        </span>
                    </div>
                    <div banner-action>
                        <button (click)="onClickPaynow()" mat-button class="button">Pay now</button>
                    </div>
                </topaz-banner>
            </ng-container>

            <ng-container *ngIf=" previousStatus != 'RENEWAL' && status==='TEST_OUT_FAIL'">
                <div class="bannerContent">
                    <topaz-banner bannerType="alert" useIcon disableScrolling disableCloseButton>
                        <div banner-content class="topaz-banner-subcontent">
                            <span class="topaz-banner-subcontent">
                                You may enrol in an Instructor-Led Training (ILT) session, which will provide you the
                                opportunity to complete the requirements and become active.
                                Your application will be reviewed and approved based on the training results. <br />
                                To access the training platform, please complete your payment using the link provided
                                below.
                            </span>
                        </div>
                        <div banner-action>
                            <button (click)="onClickPaynow()" mat-button class="button">Pay now</button>
                        </div>
                    </topaz-banner>
                </div>
            </ng-container>


            <ng-container *ngIf="status==='ILT_PAYMENT'">
                <div class="bannerContent">
                    <topaz-banner bannerType="success" useIcon disableScrolling disableCloseButton>
                        <div banner-content class="topaz-banner-subcontent">
                            <span class="topaz-banner-subcontent">
                                Your payment has been successfully completed.
                                Please be on the lookout for an email containing instructions on accessing your course.
                            </span>
                        </div>
                    </topaz-banner>
                </div>
            </ng-container>


            <ng-container *ngIf="status==='ILT_PASS'" class="bannerContent">
                <topaz-banner bannerType="success" useIcon disableScrolling disableCloseButton>
                    <div banner-content class="topaz-banner-subcontent">
                        <b>Congratulations!</b> <br />
                        <span class="topaz-banner-subcontent">
                            Welcome to Microsoft Certified Trainer! Your training results have been reviewed,
                            and you’ve successfully completed the mandatory training.
                            Your application is approved—continue to payment to start your MCT subscription.
                        </span>
                    </div>
                    <div banner-action>
                        <button (click)="onClickPaynow()" mat-button class="button">Pay now</button>
                    </div>
                </topaz-banner>
            </ng-container>


            <div *ngIf="(status==='OPEN' || status === 'FIRST_LOGIN')" class="bannerContent">
                <topaz-banner bannerType="alert" useIcon disableScrolling disableCloseButton>
                    <div banner-content class="topaz-banner-subcontent">
                        <b>Congratulations! Your MCT Application has been Submitted.</b>
                        <br /><br />
                        Welcome to the Microsoft Certified Trainer (MCT) program. To complete your enrolment and
                        activate
                        your subscription,
                        you are required to finish the mandatory training available on our platform.
                        Your application will be reviewed and approved based on the successful completion of this
                        training.
                        To gain access to the training platform, please complete your payment
                        <br />
                        Once you complete and pass your training course, you will automatically be enrolled in the MCT
                        program and gain access to your portal.
                        <br />
                    </div>
                    <div banner-action>
                        <button (click)="onClickPaynow()" mat-flat-button class="topaz-button-small button"
                            id="smallStandardPrimaryBtn">
                            Pay now
                        </button>
                    </div>
                </topaz-banner>
            </div>

            <ng-template #helpBlock>
                <mat-card class="help-req-wrapper">
                    <mat-card-title class="help-req-title topaz-banner-subcontent">
                        <p>Send us a request</p>
                    </mat-card-title>
                    <mat-card-content class="help-req-content topaz-banner-subcontent">
                        If you have any questions or encounter issues related to enrolment in the assessment, please
                        contact
                        us at<br />
                        <a aria-label="Email MCT Support at mctpvsupport@pearson.com"
                            href="mailto:mctpvsupport@pearson.com">mctpvsupport&#64;pearson.com</a>- we're here to help!
                    </mat-card-content>
                </mat-card>
            </ng-template>

            <div *ngIf="(
                     status === 'ACTIVE_MCT' || status === 'ALUMNI' || 
                     status === 'RENEWAL_APPROVE' || status === 'RENEWAL' || status === 'RENEWAL_REJECT' ||
                     (status === 'RENEWAL_EXAM' && previousStatus === 'RENEWAL') || 
                     (status === 'TEST_OUT_FAIL' && previousStatus === 'RENEWAL') || 
                     (status === 'TEST_OUT_OPEN' && previousStatus === 'RENEWAL') || 
                     (status === 'TEST_OUT_PAYMENT' && previousStatus === 'RENEWAL') || 
                     (status === 'ILT_FAIL' && previousStatus === 'RENEWAL') ||
                     (status === 'ILT_PAYMENT' && previousStatus === 'RENEWAL') || 
                     (status === 'TEST_OUT_PASS' && previousStatus === 'RENEWAL') 
                     ) else helpBlock" class="anouncement-cards">
                <mat-card class="example-card" appearance="outlined">
                    <mat-card-header class="anouncementCardTitle">
                        <mat-card-title>
                            <div class="anoucements-badge " matBadgeOverlap="false">Announcements
                                <topaz-badge class="custom-badge" color="#B4D6FA"> {{anouncementCount}} </topaz-badge>
                            </div>
                        </mat-card-title>
                        <button [disabled]="isPayDisabled" class="topaz-button-small viewAll"
                            id="smallStandardPrimaryBtn" (click)="openAnnouncementPage()" mat-flat-button
                            color="secondary">View all</button>
                    </mat-card-header>
                    <div class="pt-8"><mat-divider aria-hidden="true"></mat-divider></div>
                    <div *ngFor="let announcement of announcements;let i=index">
                        <mat-card-content>
                            <mat-card-subtitle class="card-Subtitle">
                                <h3 class="card-title"> {{announcement?.title}}</h3>
                                <topaz-capsule *ngIf="announcement?.new" small style="color: #115EA3 !important;"
                                    id="fullWidthPrimary" class="custom-capsule">New</topaz-capsule>
                            </mat-card-subtitle>
                            <p class="card-Description c-707070"> {{announcement.description}} </p>
                        </mat-card-content>
                        <br>
                        <div>
                            <button mat-stroked-button class="topaz-button-small viewPost" id="smallSecondaryPrimaryBtn"
                                color="secondary" (click)="openAnnouncementDialog(announcement)">View post</button>
                        </div>
                        <div class="pt-8"><mat-divider aria-hidden="true"></mat-divider></div>
                    </div>
                </mat-card>
            </div>
        </ng-template>
    </div>
</div>